// import { API_BASE_URL } from "../../Config";
// import axios from "axios";
// import { createAsyncThunk } from "@reduxjs/toolkit";

// export const fetchSideBarAsanas = createAsyncThunk(
//   "sideBarAsana/fetchSideBarAsanas",
//   async (filter, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/asanadetails`, {
//         params: { ...filter },
//       });
//       return response.data?.asanas;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   },
// );

// export const fetchAsanaById = createAsyncThunk(
//   "sideBarAsana/fetchAsanaById",
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/asanadetails/${id}`);
//       console.log("Full API response:", response.data);
//       console.log(
//         "Asana variationPoses:",
//         response.data?.asana?.variationPoses,
//       );
//       console.log("User variationPoses:", response.data?.variationPoses);

//       return {
//         ...response.data?.asana, // original asana details
//         userVariationPoses: response.data?.variationPoses || [], // user approved variations
//       };
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   },
// );


import { API_BASE_URL } from "../../Config";
import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchSideBarAsanas = createAsyncThunk(
  "sideBarAsana/fetchSideBarAsanas",
  async (filter, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/asanadetails`, {
        params: { ...filter },
      });
      return response.data?.asanas;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  },
);

// ✅ URL uses slug, but API call still uses MongoDB _id (no backend change needed)
export const fetchAsanaBySlug = createAsyncThunk(
  "sideBarAsana/fetchAsanaBySlug",
  async ({ id }, { rejectWithValue }) => {  // ← receives _id, not slug
    try {
      const response = await axios.get(`${API_BASE_URL}/asanadetails/${id}`); // ← _id to backend

      console.log("Full API response:", response.data);
      console.log("Asana variationPoses:", response.data?.asana?.variationPoses);
      console.log("User variationPoses:", response.data?.variationPoses);

     return {
  ...response.data?.asana,
  userVariationPoses: response.data?.asana?.userVariationPoses || [],
};
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  },
);